import { cloneDeep } from "lodash";
import React, { useState } from "react";
import { IoIosArrowDown, IoIosArrowForward, IoMdEyeOff } from "react-icons/io";
import { calculateFileSize } from "./helper";
import { FaDownload, FaEye } from "react-icons/fa";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { FaClipboardList } from "react-icons/fa";
import moment from "moment";
// import { providerNoteSlice } from "../../_redux/providerNoteSlice";
import Share from "../../components/ShareEmaileFax/Share";

function ShareDownload({ shareDataList, setShareDataList, selectedChat }) {
  const [shareDialog, setShareDialog] = useState({
    state: false,
    fileData: null,
  });
  const dispatch = useDispatch();
  const {
    practice: { id: practice_id },
    auth: authToken,
  } = JSON.parse(localStorage.getItem("auth"));
  const showComments = (comment) => {
    const confirmationDialogObj = {
      skipCancel: true,
      open: true,
      title: "Share Data Comments",
      msg: comment,
      btnOK: {
        text: "Cancel",
      },
      btCancel: { text: "Cancel" },
    };
    dispatch();
    // actions.initConfirmationDialog({ data: { ...confirmationDialogObj } })
  };
  
  return (
    <div className="text-left">
      {shareDialog?.state && (
        <Share
          from={"document"}
          sharePreviewUrl={"messages/read_attachment?uuid"}
          printData={"printData"}
          setShowShareeFax={setShareDialog}
          shouldCallPrepareDataApi={false}
          userUniqueId={{
            uuid: shareDialog?.fileData?.file_uuid,
            title: "document",
          }}
          hasFileData={shareDialog?.fileData}
          selectedChat={selectedChat}
        />
      )}
      <div className="grid grid-cols-6 bg-teal1000 text-white px-3 py-1">
        <div>Generated On</div>
        <div>Generated By</div>
        <div>File</div>
        <div>Downloaded</div>
        <div>Shared</div>
        <div className="text-center">Comments</div>
      </div>
      {shareDataList?.map((v, k) => (
        <>
          <div className="grid grid-cols-6 px-3 py-2 border flex items-center">
            <div className="flex items-center cursor-pointer select-none">
              <span
                onClick={() => {
                  let processList = cloneDeep(shareDataList);
                  processList[k].toggle = !processList[k].toggle;
                  setShareDataList(processList);
                }}
              >
                {v?.toggle ? (
                  <IoIosArrowDown size={20} />
                ) : (
                  <IoIosArrowForward size={20} />
                )}
              </span>
              {moment(v?.ShareDataTransaction?.created).format(
                "YYYY-MM-DD hh:mm A"
              )}
            </div>
            <div>{v?.SharedBy?.fname + " " + v?.SharedBy?.lname}</div>
            <div className="text-sky-500 cursor-pointer">
              {calculateFileSize(v?.ShareDataTransaction?.filesize)}
            </div>
            <div className="flex ">
              {v?.ShareDataTransaction?.download_information ? (
                <div>
                  <p>
                    By:{" "}
                    {
                      v?.ShareDataTransaction?.download_information
                        ?.downloaded_by
                    }
                  </p>
                  <p>
                    On:{" "}
                    {moment(
                      v?.ShareDataTransaction?.download_information
                        ?.downloaded_at
                    ).format("YYYY-MM-DD hh:mm A")}
                  </p>
                </div>
              ) : (
                <div className="cursor-pointer ml-10 ">
                  <FaDownload className="text-sky-600" size={20} />
                </div>
              )}
            </div>
            <div className="flex">
              {v?.ShareDataTransaction?.share_information ? (
                <div>
                  {/* <p>
                    Using Email:{" "}
                    {v?.ShareDataTransaction?.share_information?.share_with}
                  </p> */}
                  <p>
                    By: {v?.ShareDataTransaction?.share_information?.shared_by}
                  </p>
                  <p>
                    On:{" "}
                    {moment(
                      v?.ShareDataTransaction?.share_information?.share_at
                    ).format("YYYY-MM-DD hh:mm A")}
                  </p>
                </div>
              ) : (
                <div
                  className="bg-teal1000 px-3 py-1 text-white cursor-pointer"
                  onClick={() => {
                    setShareDialog({
                      state: true,
                      fileData: v?.ShareDataTransaction,
                    });
                  }}
                >
                  Share
                </div>
              )}
            </div>
            <div className="flex justify-center items-center">
              {v?.ShareDataTransaction?.share_information?.comments ? (
                <FaClipboardList
                  size={20}
                  className="text-green-600"
                  onClick={() => {
                    showComments(
                      v?.ShareDataTransaction?.share_information?.comments
                    );
                  }}
                />
              ) : (
                <FaClipboardList size={20} />
              )}
            </div>
          </div>
          <>
            {v?.toggle && (
              <div className="border-4 divide-y-2">
                {v?.ShareDataTransaction?.details?.map((detailData) => (
                  <div className=" grid grid-cols-6 px-3 py-2 flex items-center">
                    <div
                      className="col-span-2"
                      dangerouslySetInnerHTML={{ __html: detailData?.title }}
                    />
                    <div className="capitalize">{detailData?.type}</div>
                    <div className="flex ml-10 ">
                      {detailData?.file_uuid ? (
                        <>
                          <FaEye
                            onClick={() => {
                              window.open(
                                `${
                                  process.env.REACT_APP_API_URL_V1
                                }/utilities/get_attachment.json?attachment=${
                                  detailData?.file_uuid
                                }&token=${authToken}&tz=${new Date().getTimezoneOffset()}`,
                                "_blank"
                              );
                            }}
                            size={20}
                            className="text-sky-700 cursor-pointer"
                          />
                        </>
                      ) : (
                        <>
                          <IoMdEyeOff size={20} />
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        </>
      ))}
    </div>
  );
}

export default ShareDownload;
